import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { catchApiError } from "../../../lib/utils/catchApiError";
import { Agreement, IClientType, LoadingStatusCode } from "../../../lib/types";
import { Account } from "../../../lib/interfaces";
import { fetchAccountsRoute, fetchAgreementsRoute } from "../../../lib/routes/agreementsSearch";
import { IAgreementSearchParams } from "./types/IAgreementSearchParams";
import { IAccountSearchParams } from "./types/IAccountSearchParams";

interface IFetchAccountsByProps {
  clientType?: IClientType;
  name?: string;
  externalId?: string;
  property?: {
    typeAlias: "INN" | "BIN";
    stringValue: string;
  };
}
interface AgreementsSearchState {
  accounts: Account[];
  accountsLoading: LoadingStatusCode;
  // accountsByName: Account[];
  // accountsByNameLoading: LoadingStatusCode;
  // accountsByBin: Account[];
  // accountsByBinLoading: LoadingStatusCode;
  // accountsByInn: Account[];
  // accountsByInnLoading: LoadingStatusCode;
  agreements: Agreement[];
  agreementsData?: {
    content: Agreement[];
    number: number;
    size: number;
    totalElements: number;
    totalPages: number;
  };
  agreementsLoading: LoadingStatusCode;
}

const initialState: AgreementsSearchState = {
  accounts: [],
  accountsLoading: "idle",
  // accountsByName: [],
  // accountsByNameLoading: "idle",
  // accountsByInn: [],
  // accountsByBinLoading: "idle",
  // accountsByBin: [],
  // accountsByInnLoading: "idle",
  agreements: [],
  agreementsData: undefined,
  agreementsLoading: "idle",
};

export const fetchAccounts = createAsyncThunk(
  "agreementsSearch/fetchAccounts",
  async (props: IFetchAccountsByProps) => {
    const { name, clientType, property, externalId } = props;
    const searchParams: IAccountSearchParams = {};
    if (name && clientType === "ORGANIZATION") {
      searchParams["organization.fullName"] = name;
    }
    if (name && clientType === "INDIVIDUAL") {
      searchParams["individual.fullName"] = name;
    }
    if (property) {
      searchParams["organization.property.typeAlias"] = property.typeAlias;
      searchParams["organization.property.stringValue"] = property.stringValue;
    }
    if (externalId) {
      searchParams["subscriber.externalId"] = externalId;
      searchParams.clientType = clientType;
    }
    try {
      const response = axios.get(fetchAccountsRoute(searchParams));
      const { data } = await response;
      return data;
    } catch (e) {
      return catchApiError({
        e,
        title: "Ошибка загрузки аккаунтов. Попробуйте позже",
      });
    }
  }
);

// export const fetchAccountsByName = createAsyncThunk(
//   "agreementsSearch/fetchAccountsByName",
//   async (props: { name: string; clientType: IClientType }) => {
//     const { name, clientType } = props;
//     try {
//       const response = axios.get(
//         fetchAccountsRoute({ [`${clientType.toLowerCase()}.fullName`]: name, page: 0, size: 20 })
//       );
//       const { data } = await response;
//       return data;
//     } catch (e) {
//       return catchApiError({
//         e,
//         title: "Ошибка загрузки аккаунтов. Попробуйте позже",
//       });
//     }
//   }
// );

// export const fetchAccountsByInn = createAsyncThunk(
//   "agreementsSearch/fetchAccountsByInn",
//   async (inn: string) => {
//     try {
//       const response = axios.get(
//         fetchAccountsRoute({
//           "organization.property.typeId": "INN",
//           "organization.property.stringValue": inn,
//           page: 0,
//           size: 20,
//         })
//       );
//       const { data } = await response;
//       return data;
//     } catch (e) {
//       return catchApiError({
//         e,
//         title: "Ошибка загрузки аккаунтов. Попробуйте позже",
//       });
//     }
//   }
// );

// export const fetchAccountsByBin = createAsyncThunk(
//   "agreementsSearch/fetchAccountsByBin",
//   async (bin: string) => {
//     try {
//       const response = axios.get(
//         fetchAccountsRoute({
//           "organization.property.typeId": "BIN",
//           "organization.property.stringValue": bin,
//           page: 0,
//           size: 20,
//         })
//       );
//       const { data } = await response;
//       return data;
//     } catch (e) {
//       return catchApiError({
//         e,
//         title: "Ошибка загрузки аккаунтов. Попробуйте позже",
//       });
//     }
//   }
// );

export const fetchAgreements = createAsyncThunk(
  "agreementsSearch/fetchAgreements",
  async (params: IAgreementSearchParams) => {
    try {
      const response = axios.get(fetchAgreementsRoute(params));
      const { data } = await response;
      return data;
    } catch (e) {
      return catchApiError({
        e,
        title: "Ошибка загрузки договоров. Попробуйте позже",
      });
    }
  }
);

const agreementsSearchSlice = createSlice({
  name: "agreementsSearch",
  initialState,
  reducers: {
    cleanAccounts: (state) => {
      state.accountsLoading = "idle";
      state.accounts = [];
    },
    // cleanAccountsByName: (state) => {
    //   state.accountsByNameLoading = "idle";
    //   state.accountsByName = [];
    // },
    // cleanAccountsByInn: (state) => {
    //   state.accountsByInnLoading = "idle";
    //   state.accountsByInn = [];
    // },
    // cleanAccountsByBin: (state) => {
    //   state.accountsByBinLoading = "idle";
    //   state.accountsByBin = [];
    // },
    cleanAgreements: (state) => {
      state.agreementsLoading = "idle";
      state.agreements = [];
      state.agreementsData = undefined;
    },
    cleanAgreementsData: (state) => {
      state.agreementsData = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAccounts.pending, (state) => {
        state.accountsLoading = "pending";
      })
      .addCase(fetchAccounts.rejected, (state) => {
        state.accountsLoading = "rejected";
      })
      .addCase(fetchAccounts.fulfilled, (state, { payload }) => {
        state.accountsLoading = "fulfilled";
        state.accounts = payload.content;
      })
      // .addCase(fetchAccountsByName.pending, (state) => {
      //   state.accountsByNameLoading = "pending";
      // })
      // .addCase(fetchAccountsByName.rejected, (state) => {
      //   state.accountsByNameLoading = "rejected";
      // })
      // .addCase(fetchAccountsByName.fulfilled, (state, { payload }) => {
      //   state.accountsByNameLoading = "fulfilled";
      //   state.accountsByName = payload.content;
      // })
      // .addCase(fetchAccountsByInn.pending, (state) => {
      //   state.accountsByBinLoading = "pending";
      // })
      // .addCase(fetchAccountsByInn.rejected, (state) => {
      //   state.accountsByBinLoading = "rejected";
      // })
      // .addCase(fetchAccountsByInn.fulfilled, (state, { payload }) => {
      //   state.accountsByBinLoading = "fulfilled";
      //   state.accountsByInn = payload.content;
      // })
      // .addCase(fetchAccountsByBin.pending, (state) => {
      //   state.accountsByBinLoading = "pending";
      // })
      // .addCase(fetchAccountsByBin.rejected, (state) => {
      //   state.accountsByBinLoading = "rejected";
      // })
      // .addCase(fetchAccountsByBin.fulfilled, (state, { payload }) => {
      //   state.accountsByBinLoading = "fulfilled";
      //   state.accountsByBin = payload.content;
      // })
      .addCase(fetchAgreements.pending, (state) => {
        state.agreementsLoading = "pending";
      })
      .addCase(fetchAgreements.rejected, (state) => {
        state.agreementsLoading = "rejected";
      })
      .addCase(fetchAgreements.fulfilled, (state, { payload }) => {
        state.agreementsLoading = "fulfilled";
        state.agreements = [...state.agreements, ...payload.content];
        state.agreementsData = payload;
        /* Поиск договоров осуществляется в модалке раcширенного поиска, по выбору договора/ов, id аккаунтов
          передаются в форму расширенного поиска, поэтому список аккаунтов записывается в  accountsByName */
        // state.accountsByNameLoading = "fulfilled";
        // state.accountsByName = payload.content.map(({ account }) => account);
        state.accountsLoading = "fulfilled";
        state.accounts = payload.content.map(({ account }) => account);
      });
  },
});

export const {
  reducer: agreementsSearchReducer,
  actions: agreementsSearchActions,
} = agreementsSearchSlice;
